import React from 'react';
import { TableRow, TableCell } from '../ui/table';
import { cn } from '../ui/utils';
import ActivityActionButton from './ActivityActionButton';

const STATUS_STYLES = {
  completed: { label: 'Completed', className: 'text-green-600' },
  'in-progress': { label: 'In Progress', className: 'text-amber-500' },
  pending: { label: 'Pending', className: 'text-gray-400' },
  'yet-to-start': { label: 'Yet to Start', className: 'text-gray-400' }
};

function ActivityTableRow({ activity, isSelected, onToggle, onView }) {
  const status = STATUS_STYLES[activity.status] || STATUS_STYLES['yet-to-start'];
  const TypeIcon = activity.TypeIcon;

  return (
    <TableRow
      className={cn(
        'border-b border-gray-100 transition-colors',
        isSelected ? 'bg-primary/5' : 'hover:bg-gray-50/70'
      )}
    >
      <TableCell className="py-4 pl-2 pr-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(activity.id)}
          className="rounded border-gray-300 text-primary focus:ring-primary/30"
          aria-label={`Select ${activity.title}`}
        />
      </TableCell>

      <TableCell className="py-4 pr-4">
        <span className={cn('text-sm font-medium', status.className)}>{status.label}</span>
      </TableCell>

      <TableCell className="py-4 pr-4">
        <div className="flex items-center gap-3">
          <div
            className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full"
            style={{ backgroundColor: activity.colors.iconBg }}
          >
            {TypeIcon ? (
              <TypeIcon className="h-4 w-4" style={{ color: activity.colors.iconColor }} strokeWidth={1.8} />
            ) : null}
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-900">{activity.title}</p>
            <p className="text-xs text-gray-400">
              {activity.subjectName} · {activity.typeName}
            </p>
          </div>
        </div>
      </TableCell>

      <TableCell className="whitespace-nowrap py-4 pr-4">
        <p className="text-sm text-gray-600">{activity.startParts?.date}</p>
        {activity.startParts?.time ? (
          <p className="text-xs text-gray-400">{activity.startParts.time}</p>
        ) : null}
      </TableCell>

      <TableCell className="whitespace-nowrap py-4 pr-4">
        <p className="text-sm text-gray-600">{activity.endParts?.date}</p>
        {activity.endParts?.time ? (
          <p className="text-xs text-gray-400">{activity.endParts.time}</p>
        ) : null}
      </TableCell>

      <TableCell className="py-4 pr-4">
        {activity.score ? (
          <span className="inline-block rounded-md bg-gray-100 px-2.5 py-1 text-xs font-medium text-gray-700">
            {activity.score}
          </span>
        ) : (
          <span className="text-sm text-gray-300">—</span>
        )}
      </TableCell>

      <TableCell className="py-4">
        <ActivityActionButton activity={activity} onView={onView} />
      </TableCell>
    </TableRow>
  );
}

export default ActivityTableRow;
